import { AsideInfo } from '@components'

import { Button, Flex, Link, SkeletonBox, Spacing, Text } from '@billy/design-system'
import React, { ReactElement, useCallback } from 'react'
import { useTranslation } from 'react-i18next'

import { useSkatConnection } from '@features/vatDeclarations/contexts/skatConnectionContext'
import { IntegrationFormFlow } from '@features/vatDeclarations/enums/integrationFormFlow'

import { SkatLogo } from '../../../../assets/images'
import { useSegment } from '../../../../hooks'
import * as Styled from './styles'

export const SkatBox = (): ReactElement => {
  const { t } = useTranslation()
  const { track } = useSegment()
  const { isLoading, isSkatConnected, isValidCVR, setSkatShowConnectionView, setSkatShowDisconnectionView } =
    useSkatConnection()

  const handleConnectToSkatClick = useCallback(() => {
    setSkatShowConnectionView(true)
    track('xxx - Bookkeeping - DK VAT integration', {
      flow: IntegrationFormFlow.Connect,
      step: '1 - How to',
    })
  }, [setSkatShowConnectionView, track])

  const handleDisconnectFromSkatClick = useCallback(() => {
    setSkatShowDisconnectionView(true)
    track('xxx - Bookkeeping - DK VAT integration', {
      flow: IntegrationFormFlow.Disconnect,
      step: '1 - How to',
    })
  }, [setSkatShowDisconnectionView, track])

  const SkatBoxContent = isSkatConnected ? (
    <>
      <Text>{t('skat_box.connected_automatic')}</Text>
      <Button onClick={handleDisconnectFromSkatClick} variant="text" fullWidth disabled={!isValidCVR}>
        {t('skat_box.disconnect')}
      </Button>
    </>
  ) : (
    <>
      <Text>{t('skat_box.connected_manual')}</Text>

      <Button disabled={!isValidCVR} onClick={handleConnectToSkatClick} fullWidth>
        {t('skat_box.connect')}
      </Button>

      <Text nowrap>
        <Link
          withAnimation
          target="_blank"
          href="https://help.shine.co/da/articles/625998-sadan-indberetter-du-moms-til-skat-via-shine-regnskab"
        >
          {t('skat_box.guide_link')}
        </Link>
      </Text>
    </>
  )

  return (
    <Styled.SkatBoxWrapper>
      <AsideInfo>
        <Flex flexDirection="column" gap={Spacing.S16} alignItems="center">
          <SkatLogo />
          {isLoading ? (
            <>
              <SkeletonBox height={20} fullWidth />
              <SkeletonBox height={20} fullWidth />
              <SkeletonBox height={20} fullWidth />
            </>
          ) : (
            SkatBoxContent
          )}
        </Flex>
      </AsideInfo>
    </Styled.SkatBoxWrapper>
  )
}
